<script setup lang="ts">
  const props = defineProps<{
    clearable?: boolean
    maxLength: number | string
    modelValue: string
    placeholder: string
  }>()

  const emit = defineEmits<{
    (event: 'update:modelValue', value: string): void
    (event: 'search'): void
    (event: 'blur'): void
    (event: 'focus'): void
  }>()

  const searchInput = computed({
    get() {
      return props.modelValue
    },
    set(value) {
      emit('update:modelValue', value)
    },
  })

  const inputRef = useTemplateRef('inputRef')

  const handleSearch = () => {
    emit('search')
    inputRef.value?.blur()
  }

  const handleClear = async () => {
    await nextTick()
    handleSearch()
  }

  const focusInput = () => {
    inputRef.value?.focus()
  }

  defineExpose({
    focusInput,
  })
</script>

<template>
  <NInput
    ref="inputRef"
    v-model:value="searchInput"
    :placeholder="placeholder"
    :clearable="clearable"
    :input-props="{
      type: 'search',
      inputmode: 'search',
      enterkeyhint: 'search',
      'aria-label': $t('base_search'),
    }"
    @keydown.enter="handleSearch"
    @blur="$emit('blur')"
    @focus="$emit('focus')"
    @clear="handleClear"
  >
    <template #prefix>
      <i
        class="fa-regular fa-magnifying-glass text-icon-hover cursor-pointer"
        :aria-label="$t('base_search')"
        tabindex="0"
        role="button"
        @click="handleSearch"
      />
    </template>
  </NInput>
</template>
